export const AutoCompleteStyle = {
  width: '100%',

  '&.MuiAutocomplete-root .MuiOutlinedInput-root': {
    padding: 0,
    borderRadius: '8px',
    '& .MuiOutlinedInput-notchedOutline': {
      border: '1px solid',
      borderColor: '#e5e5e5',
    },

    '&:hover .MuiOutlinedInput-notchedOutline': {
      borderColor: '#b1c7a0',
    },
    '&:focus-within .MuiOutlinedInput-notchedOutline': {
      border: '1px solid #a0bbbd',
      boxShadow: '0 0 0 4px #dde6c1',
    },
    '& .MuiAutocomplete-input': {
      boxSizing: 'border-box',
      height: '44px',
      paddingY: 1.25,
      paddingX: 1.5,
      fontSize: '15px',
      lineHeight: 1.5,
      borderRadius: '8px',
    },
  },
}
